import styled from 'styled-components';

export const DraggableInfo = styled.div.attrs({ className: 'body_text' })`
  display: flex;
  border-radius: 0;
  color: ${({ theme }) => theme.baseBlue.a6};
  align-items: center;
  cursor: move;
  > span {
    margin-left: 15px;
  }
`;

export const DraggableIcon = styled.div`
  width: 18px;
  height: 14px;
  cursor: move;
`;
